import { Waves } from "lucide-react";
import { Link } from "wouter";

export default function PrivacyPolicy() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-deep-navy text-white py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <Link href="/" className="flex items-center text-2xl font-playfair font-bold">
              <Waves className="w-8 h-8 mr-2" />
              South FL<span className="text-luxury-gold">Waterfront</span>
            </Link>
            <Link href="/" className="text-luxury-gold hover:text-yellow-300 transition-colors duration-200">
              Back to Home
            </Link>
          </div>
        </div>
      </header>

      {/* Privacy Policy Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-playfair font-bold text-deep-navy mb-8">Privacy Policy</h1>
        <p className="text-gray-600 mb-8">Last updated: August 25, 2025</p>

        <div className="prose prose-lg max-w-none text-gray-700 space-y-6">
          <p>
            This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.
          </p>

          <p>
            We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy. This Privacy Policy has been created with the help of the Privacy Policy Generator.
          </p>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">Fair Housing Compliance</h2>
          <p>
            We comply fully with the Fair Housing Act and do not discriminate against any person on the basis of race, color, religion, sex, handicap, familial status, or national origin.
          </p>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">Interpretation and Definitions</h2>
          
          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Interpretation</h3>
          <p>
            The words of which the initial letter is capitalized have meanings defined under the following conditions. The following definitions shall have the same meaning regardless of whether they appear in singular or in plural.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Definitions</h3>
          <p>For the purposes of this Privacy Policy:</p>
          
          <ul className="list-disc pl-6 space-y-2">
            <li><strong>Account</strong> means a unique account created for You to access our Service or parts of our Service.</li>
            <li><strong>Affiliate</strong> means an entity that controls, is controlled by or is under common control with a party, where "control" means ownership of 50% or more of the shares, equity interest or other securities entitled to vote for election of directors or other managing authority.</li>
            <li><strong>Company</strong> (referred to as either "the Company", "We", "Us" or "Our" in this Agreement) refers to QPS Investments LLC, 11815 east baseline rd.</li>
            <li><strong>Cookies</strong> are small files that are placed on Your computer, mobile device or any other device by a website, containing the details of Your browsing history on that website among its many uses.</li>
            <li><strong>Country</strong> refers to: Florida, United States</li>
            <li><strong>Device</strong> means any device that can access the Service such as a computer, a cellphone or a digital tablet.</li>
            <li><strong>Personal Data</strong> is any information that relates to an identified or identifiable individual.</li>
            <li><strong>Service</strong> refers to the Website.</li>
            <li><strong>Service Provider</strong> means any natural or legal person who processes the data on behalf of the Company. It refers to third-party companies or individuals employed by the Company to facilitate the Service, to provide the Service on behalf of the Company, to perform services related to the Service or to assist the Company in analyzing how the Service is used.</li>
            <li><strong>Usage Data</strong> refers to data collected automatically, either generated by the use of the Service or from the Service infrastructure itself (for example, the duration of a page visit).</li>
            <li><strong>Website</strong> refers to Selling South Fl Waterfront, accessible from Sellingsouthflwaterfront.com</li>
            <li><strong>You</strong> means the individual accessing or using the Service, or the company, or other legal entity on behalf of which such individual is accessing or using the Service, as applicable.</li>
          </ul>

          <h2 className="text-2xl font-bold text-deep-navy mt-8 mb-4">Collecting and Using Your Personal Data</h2>
          
          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Types of Data Collected</h3>
          
          <h4 className="text-lg font-semibold text-deep-navy mt-4 mb-2">Personal Data</h4>
          <p>
            While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:
          </p>
          <ul className="list-disc pl-6 space-y-1">
            <li>Email address</li>
            <li>First name and last name</li>
            <li>Phone number</li>
            <li>Usage Data</li>
          </ul>

          <h4 className="text-lg font-semibold text-deep-navy mt-4 mb-2">Usage Data</h4>
          <p>
            Usage Data is collected automatically when using the Service.
          </p>
          <p>
            Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.
          </p>
          <p>
            When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.
          </p>
          <p>
            We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Tracking Technologies and Cookies</h3>
          <p>
            We may use cookies and similar tracking technologies to monitor site usage, improve performance, and deliver relevant content. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Use of Your Personal Data</h3>
          <p>The Company may use Personal Data for the following purposes:</p>
          <ul className="list-disc pl-6 space-y-2">
            <li>To provide and maintain our Service, including to monitor the usage of our Service.</li>
            <li>To manage Your Account: to manage Your registration as a user of the Service.</li>
            <li>For the performance of a contract: the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased.</li>
            <li>To contact You: To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication.</li>
            <li>To provide You with news, special offers and general information about other goods, services and events.</li>
            <li>To manage Your requests: To attend and manage Your requests to Us.</li>
            <li>For business transfers: We may use Your information to evaluate or conduct a merger, divestiture, restructuring, reorganization, dissolution, or other sale or transfer of some or all of Our assets.</li>
            <li>For other purposes: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns.</li>
          </ul>

          <h4 className="text-lg font-semibold text-deep-navy mt-4 mb-2">Sharing of Inquiry Information</h4>
          <p>
            If you submit a property inquiry, your contact information may be shared with licensed real estate brokers or agents for the purpose of responding to your request. We are not a licensed real estate brokerage. Inquiries are referred to licensed brokers or agents who can assist you.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Data Storage Location</h3>
          <p>
            Data collected may be stored and processed by third-party service providers such as cloud hosting or database services located in the United States.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Retention of Your Personal Data</h3>
          <p>
            The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations, resolve disputes, and enforce our legal agreements and policies.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Transfer of Your Personal Data</h3>
          <p>
            Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Delete Your Personal Data</h3>
          <p>
            You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You. Our Service may give You the ability to delete certain information about You from within the Service.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Disclosure of Your Personal Data</h3>
          
          <h4 className="text-lg font-semibold text-deep-navy mt-4 mb-2">Business Transactions</h4>
          <p>
            If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
          </p>

          <h4 className="text-lg font-semibold text-deep-navy mt-4 mb-2">Law Enforcement</h4>
          <p>
            Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Security of Your Personal Data</h3>
          <p>
            The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Children's Privacy</h3>
          <p>
            Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.
          </p>
          <p>
            If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Changes to this Privacy Policy</h3>
          <p>
            We may update Our Privacy Policy from time to time. We will notify You of any changes by posting the new Privacy Policy on this page. We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the "Last updated" date at the top of this Privacy Policy.
          </p>

          <h3 className="text-xl font-semibold text-deep-navy mt-6 mb-3">Contact Us</h3>
          <p>If you have any questions about this Privacy Policy, You can contact us:</p>
          <ul className="list-disc pl-6 space-y-1">
            <li>By email: info@sellingsouthflwaterfront.com</li>
            <li>On this page: <Link href="/contact" className="text-ocean-blue hover:underline">Contact Us</Link></li>
          </ul>
        </div>
      </div>
    </div>
  );
}